"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="accordion ${x => x.altDesign ? 'alt-design' : ''}" :id="${x => x.accordionId}">
    ${(0, fast_element_1.repeat)(x => x.headers, (0, fast_element_1.html) `
        <div class="accordion-item">
            <h2 class="accordion-header" id="heading-${(x, c) => c.parent.accordionId}-${x => x.id}">
                <button class="accordion-button ${(x, c) => c.parent.isItemExpanded(x.id) ? '' : 'collapsed'}" 
                        type="button" 
                        data-item-id="${x => x.id}"
                        @click="${(x, c) => c.parent.toggleItem(x.id)}"
                        aria-expanded="${(x, c) => c.parent.isItemExpanded(x.id) ? 'true' : 'false'}"
                        aria-controls="collapse-${(x, c) => c.parent.accordionId}-${x => x.id}">
                    ${x => x.title}
                    <i class="faq-icon-wrapper iconsminds-arrow-down"></i>
                </button>
            </h2>
            <div id="collapse-${(x, c) => c.parent.accordionId}-${x => x.id}" 
                 class="accordion-collapse collapse ${(x, c) => c.parent.isItemExpanded(x.id) ? 'show' : ''}"
                 aria-labelledby="heading-${(x, c) => c.parent.accordionId}-${x => x.id}"
                 data-bs-parent="#${(x, c) => c.parent.accordionId}">
                <div class="accordion-body">
                    ${(x, c) => (0, fast_element_1.html) `${c.parent.getSlotContentByIndex(c.index)}`}
                </div>
            </div>
        </div>
    `, { positioning: true })}
    <div style="display: none;">
        <slot></slot>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.accordion .accordion-item {
  border: 1px solid #dee2e6;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 15px rgba(0, 0, 0, 0.04), 0 1px 6px rgba(0, 0, 0, 0.04);
}
.accordion .accordion-item:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.accordion .accordion-item:last-child {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.accordion .accordion-header {
  margin: 0;
  position: relative;
}
.accordion .accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.7rem 1.25rem;
  font-size: 1rem;
  font-weight: 400;
  color: #212529;
  text-align: left;
  background-color: #e9ecef;
  border: none;
  border-radius: 0.5rem;
  margin: 0;
  overflow-anchor: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
}
.accordion .accordion-button:not(.collapsed) {
  color: #922c88;
  background-color: #e5c8e2;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}
.accordion .accordion-button:hover {
  z-index: 2;
}
.accordion .accordion-button:focus {
  z-index: 3;
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.accordion .accordion-button::after {
  display: none !important;
}
.accordion .accordion-button .faq-icon-wrapper {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 1.25rem;
  top: 50%;
  transform: translateY(-50%) rotate(0deg);
  transition: transform 0.3s ease-in-out;
  font-size: 0.9rem;
  line-height: 1;
  text-align: center;
}
.accordion .accordion-button:not(.collapsed) .faq-icon-wrapper {
  transform: translateY(-50%) rotate(90deg);
  color: #004d99;
}
.accordion .accordion-collapse:not(.show) {
  display: none;
}
.accordion .accordion-collapse.show {
  display: block;
}
.accordion .accordion-body {
  padding: 1rem;
}

.accordion.alt-design .accordion-item {
  border: 1px solid rgba(0, 0, 0, 0.125);
  margin-bottom: 1rem;
  border-radius: 0.375rem;
  overflow: hidden;
  box-shadow: none;
}
.accordion.alt-design .accordion-item:last-child {
  margin-bottom: 0;
}
.accordion.alt-design .accordion-button {
  background-color: #f8f9fa;
  color: #495057;
  font-weight: 600;
  padding: 1rem 1.25rem;
  border: none;
  box-shadow: none;
  border-radius: 0;
}
.accordion.alt-design .accordion-button:not(.collapsed) {
  background-color: #e7f1ff;
  color: #0d6efd;
  box-shadow: none;
}
.accordion.alt-design .accordion-button:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: transparent;
}
.accordion.alt-design .accordion-button .faq-icon-wrapper {
  font-size: 0.875rem;
  transition: transform 0.3s ease;
  transform: translateY(-50%) rotate(0deg);
}
.accordion.alt-design .accordion-button:not(.collapsed) .faq-icon-wrapper {
  transform: translateY(-50%) rotate(180deg);
}
.accordion.alt-design .accordion-body {
  padding: 1.5rem 1.25rem;
  background-color: #fff;
}

.accordion-collapse {
  transition: height 0.35s ease;
  overflow: hidden;
}

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button {
  border-radius: 0;
}

.accordion-dark .accordion-item {
  background-color: #212529;
  border: 1px solid rgba(255, 255, 255, 0.125);
}
.accordion-dark .accordion-button {
  color: #fff;
  background-color: #212529;
}
.accordion-dark .accordion-button:not(.collapsed) {
  color: #86b7fe;
  background-color: #1e2125;
}
.accordion-dark .accordion-body {
  color: #fff;
}`;
const shadowOptions = { "mode": "open" };
let AccordionComponent = class AccordionComponent extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.accordionId = 'accordion';
        this.altDesign = false;
        this.alwaysOpen = false;
        this.headers = [];
        this.expandedItems = new Set();
        this.expandedItemsArray = [];
        this.externalExpandedItems = [];
    }
    connectedCallback() {
        super.connectedCallback();
        this.initializeExpandedItems();
    }
    headersChanged() {
        // Initialize expanded items from headers when headers change
        this.initializeExpandedItems();
    }
    externalExpandedItemsChanged() {
        // Update internal expanded items when external property changes
        if (this.externalExpandedItems && Array.isArray(this.externalExpandedItems)) {
            // Ensure expandedItems is initialized
            if (!this.expandedItems) {
                this.expandedItems = new Set();
            }
            this.expandedItems = new Set(this.externalExpandedItems);
            this.expandedItemsArray = Array.from(this.expandedItems);
        }
    }
    initializeExpandedItems() {
        // Ensure expandedItems is initialized
        if (!this.expandedItems) {
            this.expandedItems = new Set();
        }
        // First, check if external expanded items are provided
        if (this.externalExpandedItems && this.externalExpandedItems.length > 0) {
            this.expandedItems = new Set(this.externalExpandedItems);
        }
        else {
            // Otherwise, check headers for expanded property
            this.expandedItems.clear();
            if (this.headers) {
                this.headers.forEach(header => {
                    if (header.expanded) {
                        this.expandedItems.add(header.id);
                    }
                });
            }
        }
        this.expandedItemsArray = Array.from(this.expandedItems);
    }
    toggleItem(itemId) {
        // Ensure expandedItems is initialized
        if (!this.expandedItems) {
            this.expandedItems = new Set();
        }
        if (this.expandedItems.has(itemId)) {
            this.expandedItems.delete(itemId);
        }
        else {
            if (!this.alwaysOpen) {
                // Close all other items if not always open
                this.expandedItems.clear();
            }
            this.expandedItems.add(itemId);
        }
        // Trigger reactivity by updating both the Set and the array
        this.expandedItems = new Set(this.expandedItems);
        this.expandedItemsArray = Array.from(this.expandedItems);
        // Emit custom event
        this.$emit('accordion-toggle', {
            itemId,
            expanded: this.expandedItems.has(itemId),
            expandedItems: this.expandedItemsArray
        });
    }
    isItemExpanded(itemId) {
        return this.expandedItems ? this.expandedItems.has(itemId) : false;
    }
    getAccordionItemId(itemId) {
        return `${this.accordionId}-${itemId}`;
    }
    getCollapseId(itemId) {
        return `collapse-${this.accordionId}-${itemId}`;
    }
    getHeadingId(itemId) {
        return `heading-${this.accordionId}-${itemId}`;
    }
    generateAccordionHTML() {
        if (!this.headers || this.headers.length === 0) {
            return '';
        }
        return this.headers.map(header => {
            const isExpanded = this.isItemExpanded(header.id);
            const slotContent = this.getSlotContent(`content-${header.id}`);
            return `
                <div class="accordion-item">
                    <h2 class="accordion-header" id="heading-${this.accordionId}-${header.id}">
                        <button class="accordion-button ${isExpanded ? '' : 'collapsed'}" 
                                type="button" 
                                data-item-id="${header.id}"
                                aria-expanded="${isExpanded ? 'true' : 'false'}"
                                aria-controls="collapse-${this.accordionId}-${header.id}">
                            ${header.title}
                            <i class="faq-icon-wrapper iconsminds-arrow-down"></i>
                        </button>
                    </h2>
                    <div id="collapse-${this.accordionId}-${header.id}" 
                         class="accordion-collapse collapse ${isExpanded ? 'show' : ''}"
                         aria-labelledby="heading-${this.accordionId}-${header.id}"
                         data-bs-parent="#${this.accordionId}">
                        <div class="accordion-body">
                            ${slotContent}
                        </div>
                    </div>
                </div>
            `;
        }).join('');
    }
    getSlotContent(slotName) {
        const slotElement = this.querySelector(`[slot="${slotName}"]`);
        return slotElement ? slotElement.innerHTML : '';
    }
    getSlotContentByIndex(index) {
        const header = this.headers[index];
        if (!header)
            return '';
        return this.getSlotContent(`content-${header.id}`);
    }
    expandAll() {
        if (this.alwaysOpen && this.headers) {
            this.headers.forEach(header => {
                this.expandedItems.add(header.id);
            });
            this.expandedItems = new Set(this.expandedItems);
            this.expandedItemsArray = Array.from(this.expandedItems);
        }
    }
    collapseAll() {
        this.expandedItems.clear();
        this.expandedItems = new Set();
        this.expandedItemsArray = [];
    }
};
exports.AccordionComponent = AccordionComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], AccordionComponent.prototype, "accordionId", void 0);
__decorate([
    (0, client_1.attr)({ mode: 'boolean' }),
    __metadata("design:type", Boolean)
], AccordionComponent.prototype, "altDesign", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Boolean)
], AccordionComponent.prototype, "alwaysOpen", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccordionComponent.prototype, "headers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof Set !== "undefined" && Set) === "function" ? _a : Object)
], AccordionComponent.prototype, "expandedItems", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccordionComponent.prototype, "expandedItemsArray", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], AccordionComponent.prototype, "externalExpandedItems", void 0);
exports.AccordionComponent = AccordionComponent = __decorate([
    (0, client_1.RWSView)('rws-accordion', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], AccordionComponent);
AccordionComponent.defineComponent();
